import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeadersModule } from '@shared/core/components/headers';
import { EmphasisTextModule } from '@shared/core/components/emphasisText';
import { LinkModule } from '@shared/core/components/link';
import { ButtonsModule } from '@shared/core/components/buttons';
import { ProjectionModule } from '@shared/core/components/projection';

import { AccountMemberHeroHeaderComponent } from './account-member-hero-header.shared.component';

@NgModule({
    declarations: [
        AccountMemberHeroHeaderComponent
    ],
    imports: [
        CommonModule,
        HeadersModule,
        EmphasisTextModule,
        LinkModule,
        ButtonsModule,
        ProjectionModule,
    ],
    exports: [
        AccountMemberHeroHeaderComponent
    ],
    providers: [
    ],
})
export class AccountMemberHeroHeaderModule { }
